import Vue from "vue";
import VipPopup from "@/components/VipPop.vue";

export default function showVipPopup() {
  const Popup = Vue.extend(VipPopup);
  const instance = new Popup({
    propsData: { value: true },
  });
  instance.$mount();
  document.body.appendChild(instance.$el);

  // 监听关闭后销毁
  instance.$on("input", (val) => {
    if (!val) {
      instance.$destroy();
      document.body.removeChild(instance.$el);
    }
  });
}
